var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "confirmLoadEmailTemplateModal",
    attrs: { id: "confirm-load-email-template-modal", "loaders-disabled": "" },
    on: { hide: _vm.handleHide },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t("client-profile.actions.confirmLoadEmailTemplate")
                ) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t("client-profile.actions.confirmLoadEmailTemplateText")
                ) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: { loading: _vm.loading },
                on: { click: _vm.handleConfirmClick },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("automations.boardLevel.loadEmailTemplate")) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }